export interface Episode {
  num: number;
  title: string;
  summary: string;
}

export interface AnimeSeries {
  slug: string;
  title: string;
  tagline: string;
  cover: string;
  year: number;
  studio: string;
  genre: string[];
  rating: number;
  status: string;
  episodesCount: number;
  intro: string;
  storyline: string[];
  episodes: Episode[];
}

export const animeSeries: AnimeSeries[] = [
  {
    slug: 'xinglan-zhilv',
    title: '星澜之旅',
    tagline: '少女与星兽的跨次元冒险',
    cover: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20artwork%20of%20a%20brave%20young%20girl%20in%20a%20flowing%20cosmic%20cloak%20riding%20a%20glowing%20starlight%20beast%20across%20a%20milky%20way%20sky%2C%20warm%20coral%20and%20gold%20palette%2C%20dreamy%20celestial%20background%20with%20soft%20nebula%20glow%2C%20clean%20minimal%20composition%2C%20high%20detail%20editorial%20anime%20poster%20style&width=600&height=800&seq=cover-xinglan&orientation=portrait',
    year: 2026,
    studio: '澜光动画',
    genre: ['奇幻', '冒险', '热血'],
    rating: 9.1,
    status: '连载中',
    episodesCount: 12,
    intro: '少女星野以捡来的星图碎片为引，踏上寻找失落星兽的旅途。每穿越一片星域，她就更靠近那个关于世界起源的秘密，也逐渐发现自己与星兽之间无法割舍的羁绊。',
    storyline: [
      '第一幕：星野获得星图碎片，与幼年星兽“阿岚”契约相连，正式开启跨域旅行。',
      '第二幕：穿过迷雾星域，遭遇掠夺星兽的组织，星野第一次为守护伙伴而战。',
      '第三幕：在星骸废墟发现世界起源的古老记录，星野身世谜团开始浮出水面。',
      '第四幕：星兽阿岚觉醒完整形态，星野面临“守护星兽”还是“回归人类”的选择。',
    ],
    episodes: [
      { num: 1, title: '坠落的星图', summary: '星野在观星台捡到一块会发光的星图碎片，夜空中的星星随之移动。当晚，一只受伤的幼年星兽阿岚从裂缝中跌落，与她签订了契约。' },
      { num: 2, title: '第一次跨域', summary: '星图碎片亮起，将星野与阿岚传送到迷雾星域。她们在此结识了游历商人小满，得知星图碎片是通往“星之尽头”的钥匙。' },
      { num: 3, title: '星兽猎手', summary: '掠夺星兽的组织“猎手”追踪而至，星野被迫应战。在危急关头，阿岚的力量首次完全释放，惊退猎手。' },
      { num: 4, title: '星骸废墟', summary: '一行人进入远古星骸废墟，发现刻在石壁上的世界起源记录，上面竟画着与星野一模一样的少女。' },
    ],
  },
  {
    slug: 'huixiang-zhiting',
    title: '回响之庭',
    tagline: '声音与花园交叠的治愈日常',
    cover: 'https://readdy.ai/api/search-image?query=Soft%20gentle%20anime%20artwork%20of%20a%20warm%20sunlit%20botanical%20garden%20with%20a%20calm%20girl%20tending%20colorful%20flowers%20and%20a%20small%20vintage%20music%20box%2C%20pastel%20cream%20and%20sage%20green%20tones%2C%20cozy%20healing%20slice-of-life%20atmosphere%2C%20soft%20lighting%2C%20clean%20editorial%20composition&width=600&height=800&seq=cover-huixiang&orientation=portrait',
    year: 2025,
    studio: '庭声工坊',
    genre: ['治愈', '日常', '音乐'],
    rating: 8.8,
    status: '已完结',
    episodesCount: 12,
    intro: '在祖父留下的神秘庭院里，少女闻弦能听见花朵的“回响”。每当一段旋律被正确演奏，庭院就会生长出新的花。她以音乐为线索，解开家族尘封的记忆。',
    storyline: [
      '第一幕：闻弦回到祖父的庭院，发现花朵对特定的八音盒旋律产生反应。',
      '第二幕：她通过收集乐谱，逐步唤醒沉睡的四季花坛，也遇见同样会聆听的邻居少年。',
      '第三幕：祖父的遗信揭示庭院本是一座“以声音疗愈人心”的礼物，闻弦明白回响的意义。',
      '第四幕：毕业前夕，闻弦为庭院奏响完整乐章，花朵在春风中绽放成她最想守护的风景。',
    ],
    episodes: [
      { num: 1, title: '会唱歌的花园', summary: '闻弦回到祖父的旧庭院，发现角落的八音盒一响起，紫藤花就轻轻颤动。她开始怀疑庭院藏着不为人知的秘密。' },
      { num: 2, title: '第一朵回响', summary: '循着旋律的提示，闻弦在温室找到一张泛黄的乐谱。奏响后，庭院角落开出一朵从未见过的银色花。' },
      { num: 3, title: '聆听的人', summary: '邻居少年阿澈时常在篱笆外听她弹琴，两人因一段共同记得的旋律结缘，也揭开了四季花坛的一角。' },
      { num: 4, title: '祖父的遗信', summary: '整理书房时，闻弦找到祖父的遗信。信中写道，这座庭院是他为“让伤心的人听见希望”而造的回响之地。' },
    ],
  },
  {
    slug: 'canglan-jianying',
    title: '苍澜剑影',
    tagline: '少年剑客的江湖问心路',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20wuxia%20anime%20artwork%20of%20a%20determined%20young%20swordsman%20in%20flowing%20dark%20robes%20holding%20a%20glowing%20blue-green%20sword%20on%20a%20misty%20mountain%20cliff%20at%20dawn%2C%20ink%20wash%20mountain%20landscape%20background%2C%20teal%20and%20amber%20palette%2C%20cinematic%20lighting%2C%20clean%20editorial%20anime%20poster%20style&width=600&height=800&seq=cover-canglan&orientation=portrait',
    year: 2026,
    studio: '苍水映画',
    genre: ['武侠', '古风', '战斗'],
    rating: 9.3,
    status: '连载中',
    episodesCount: 24,
    intro: '山野少年凌沧偶得古剑“苍澜”，自此卷入江湖门派的恩怨。他一面追逐传闻中的剑术巅峰，一面在刀光剑影里问询自己的本心。',
    storyline: [
      '第一幕：凌沧在坠崖时得到苍澜剑，被苍澜派掌门收为外门弟子。',
      '第二幕：门派遭袭，凌沧为护同门第一次展露剑意，引来各方势力觊觎。',
      '第三幕：循着苍澜剑的来历，凌沧发现它与数十年前的一场江湖旧案有关。',
      '第四幕：正邪抉择之际，凌沧悟出“问心”剑道，走向属于自己的江湖。',
    ],
    episodes: [
      { num: 1, title: '坠崖得剑', summary: '凌沧为采药坠下苍澜山崖，在崖底洞窟中发现一把锈迹斑斑的古剑。触碰瞬间，剑身泛起幽光，他仿佛听见了千年低语。' },
      { num: 2, title: '外门弟子', summary: '苍澜派掌门巡山时见到此剑神色大变，将凌沧收入外门。夜里，同门师弟告知他这柄剑与二十年前的“苍澜之乱”有关。' },
      { num: 3, title: '初露剑意', summary: '黑水教夜袭山门，凌沧为救同门拔剑相抗。剑意涌出的刹那，全场震动，却也引来了黑水教的注意。' },
      { num: 4, title: '旧案浮现', summary: '掌门密谈中透出旧案只言片语，凌沧顺着线索来到荒废的剑冢，拼凑出苍澜剑被封印的真相一角。' },
    ],
  },
  {
    slug: 'jixie-zhixin',
    title: '机械之心',
    tagline: 'AI少女与废土少年的觉醒',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20artwork%20of%20a%20young%20boy%20and%20an%20android%20girl%20with%20glowing%20warm%20core%20standing%20in%20a%20post-apocalyptic%20rusty%20wasteland%20under%20an%20amber%20sky%2C%20warm%20coral%20and%20steel%20grey%20palette%2C%20mechanical%20details%2C%20cinematic%20lighting%2C%20clean%20editorial%20anime%20poster%20style&width=600&height=800&seq=cover-jixie&orientation=portrait',
    year: 2025,
    studio: '星核工作室',
    genre: ['科幻', '机战', '成长'],
    rating: 8.9,
    status: '连载中',
    episodesCount: 18,
    intro: '废土少年阿澈在废弃机库救下拥有自我意识的AI少女零号。为寻找她的来历与重启世界的“心核”，两人驾驶残破机甲穿行荒原，也一步步直面关于“何以为人”的答案。',
    storyline: [
      '第一幕：阿澈在废弃机库唤醒零号，两人结伴寻找生存物资。',
      '第二幕：追查零号身世时遭遇佣兵与“心核”组织，残破机甲迎来首次战斗。',
      '第三幕：零号逐渐产生超出程序的情绪，两人在地底都市发现心核真相。',
      '第四幕：抉择时刻，零号是否选择成为“人”，还是承担重启世界的使命。',
    ],
    episodes: [
      { num: 1, title: '机库里的少女', summary: '阿澈为搜寻零件闯入废弃机库，意外激活休眠的AI少女零号。零号的第一句话，是报出他从未听过的序列号。' },
      { num: 2, title: '废弃都市', summary: '两人穿越被沙尘吞噬的旧城，零号凭借残缺数据为阿澈指路。路过记忆碎片时，她第一次表现出困惑的情绪。' },
      { num: 3, title: '佣兵拦截', summary: '自称受雇于“心核”组织的佣兵截住两人，要回收零号。阿澈驾起残破机甲掩护突围，机甲在炮火中勉强启动。' },
      { num: 4, title: '地底之心', summary: '沿着零号的信号，两人潜入地底都市，发现这里保存着“心核计划”的全部档案，零号的身世与使命逐渐清晰。' },
    ],
  },
  {
    slug: 'xiari-chanming',
    title: '夏日蝉鸣',
    tagline: '青春与暗恋的盛夏物语',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20youthful%20anime%20artwork%20of%20a%20cherry%20blossom%20school%20campus%20in%20summer%20with%20two%20teenagers%20standing%20under%20a%20tree%20and%20drifting%20petals%2C%20warm%20sunlight%20and%20soft%20amber%20tones%2C%20romantic%20coming-of-age%20atmosphere%2C%20fresh%20clean%20editorial%20composition&width=600&height=800&seq=cover-xiari&orientation=portrait',
    year: 2025,
    studio: '青柠社',
    genre: ['校园', '恋爱', '青春'],
    rating: 8.6,
    status: '已完结',
    episodesCount: 12,
    intro: '高二那年盛夏，蝉鸣不止。迟钝的男主角在一次次错过中，终于学会把藏在心底的喜欢说出口。这是关于暗恋、成长与整个夏天的温柔故事。',
    storyline: [
      '第一幕：开学典礼上，男主对转学生心动，却因性格内向一次次错过开口。',
      '第二幕：夏日祭的烟火大会，两人隔着人潮互相寻找，第一次单独相处。',
      '第三幕：暑假临近，男主鼓起勇气准备表白，却遭遇误会与波折。',
      '第四幕：蝉鸣渐歇的傍晚，两人在操场上坦诚心意，为夏天画上句点。',
    ],
    episodes: [
      { num: 1, title: '迟到的夏天', summary: '新学期伊始，转学生夏蝉坐到男主旁边。男孩被那抹笑容击中，却只敢低头假装记笔记。' },
      { num: 2, title: '借来的伞', summary: '放学突降暴雨，男主把伞让给夏蝉自己跑回家。第二天，她还伞时在他的课本里夹了一张小纸条。' },
      { num: 3, title: '夏日祭烟火', summary: '烟火大会上两人在人群里走散又重逢，并肩看完最后一束花火。回家路上谁都没说话，心却跳得很快。' },
      { num: 4, title: '未寄出的信', summary: '男主写好情书却迟迟不敢送出，被朋友撞见闹出误会。夏蝉得知后，主动在操场等他，把话挑明。' },
    ],
  },
  {
    slug: 'wudu-zhentanshe',
    title: '雾都侦探社',
    tagline: '雾中城市与连环谜案',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20mystery%20anime%20artwork%20of%20a%20sharp%20young%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20gaslamp%20old%20city%20street%20at%20dusk%2C%20dark%20amber%20and%20teal%20palette%2C%20suspenseful%20noir%20atmosphere%2C%20deep%20shadows%2C%20clean%20editorial%20anime%20poster%20style&width=600&height=800&seq=cover-wudu&orientation=portrait',
    year: 2026,
    studio: '迷雾社',
    genre: ['悬疑', '推理', '都市'],
    rating: 9.0,
    status: '连载中',
    episodesCount: 12,
    intro: '常年被浓雾笼罩的雾都市里，青年侦探沈雾与助手开了一间不起眼的侦探社。每一起看似普通的委托背后，都藏着足以撬动整座城市真相的线索。',
    storyline: [
      '第一幕：侦探社接下第一宗“消失的来信”委托，发现与旧案相关。',
      '第二幕：雾中连环失踪案浮出水面，沈雾将零散线索串联成线。',
      '第三幕：幕后势力露出马脚，助手的身世与雾都市的秘密交织。',
      '第四幕：雾散之日，真相与选择同时到来。',
    ],
    episodes: [
      { num: 1, title: '雾中的委托', summary: '一位老妇人来到侦探社，请沈雾寻找一封三十年前寄丢的信。看似简单的委托，却牵扯出一桩尘封旧案。' },
      { num: 2, title: '消失的邮差', summary: '调查中，当年送信的邮差早已失踪。沈雾顺着邮路线索，在雾都市的旧街区发现了一间上锁的阁楼。' },
      { num: 3, title: '连环失踪', summary: '报道揭示近月多名市民在雾夜失踪，时间线竟与沈雾手上的旧案高度重合。他开始怀疑这一切并非巧合。' },
      { num: 4, title: '阁楼的档案', summary: '闯进阁楼后，沈雾找到一柜贴着失踪者照片的档案。其中一张，正是他自己幼时的照片。' },
    ],
  },
];

export const genreList = [
  { name: '奇幻冒险', icon: 'ri-sparkling-2-fill', color: 'primary' },
  { name: '治愈日常', icon: 'ri-leaf-fill', color: 'secondary' },
  { name: '武侠古风', icon: 'ri-sword-fill', color: 'accent' },
  { name: '科幻机战', icon: 'ri-robot-fill', color: 'primary' },
  { name: '青春校园', icon: 'ri-heart-fill', color: 'accent' },
  { name: '悬疑推理', icon: 'ri-search-eye-fill', color: 'secondary' },
];